import dynamic from 'next/dynamic';
export const SvgIcon = dynamic(() => import('./Icons/SvgIcon'));
export default SvgIcon;
export const EFArrowUp: any = dynamic(() => import('./Icons/EFArrowUp'));
export const EFArrowDown = dynamic(() => import('./Icons/EFArrowDown'));
export const EFArrowRight = dynamic(() => import('./Icons/EFArrowRight'));
export const EFArrowLeft: any = dynamic(() => import('./Icons/EFArrowLeft'));
export const EFArrowLeftSmall = dynamic(() => import('./Icons/EFArrowLeftSmall'));
export const EFAcInput = dynamic(() => import('./Icons/EFAcInput'));
export const EFSolarInput = dynamic(() => import('./Icons/EFSolarInput'));
export const EFCarInput = dynamic(() => import('./Icons/EFCarInput'));
export const EFCrumArrow = dynamic(() => import('./Icons/EFCrumArrow'));
export const EFBlueArrowUpSmall = dynamic(() => import('./Icons/EFBlueArrowUpSmall'));
export const EFBlueArrowUp = dynamic(() => import('./Icons/EFBlueArrowUp'));
export const EFProductPrev = dynamic(() => import('./Icons/EFProductPrev'));
export const EFProductNext = dynamic(() => import('./Icons/EFProductNext'));
export const EFLoad = dynamic(() => import('./Icons/EFLoad'));
export const EFPause = dynamic(() => import('./Icons/EFPause'));
export const EFPlay = dynamic(() => import('./Icons/EFPlay'));
export const EFBlueTick = dynamic(() => import('./Icons/EFBlueTick'));
export const EFReplayBig = dynamic(() => import('./Icons/EFReplayBig'));
export const EFPlayBig = dynamic(() => import('./Icons/EFPlayBig'));
export const EFmharrup = dynamic(() => import('./Icons/EFmharrup'));
export const EFmhAcIcon1 = dynamic(() => import('./Icons/EFmhAcIcon1'));
export const EFmhAcIcon2 = dynamic(() => import('./Icons/EFmhAcIcon2'));
export const EFmhAcIcon3 = dynamic(() => import('./Icons/EFmhAcIcon3'));
export const EFPauseBig = dynamic(() => import('./Icons/EFPauseBig'));
export const EFSearch = dynamic(() => import('./Icons/EFSearch'));
export const EFDelete = dynamic(() => import('./Icons/EFDelete'));
export const EFReplayH5 = dynamic(() => import('./Icons/EFReplayH5'));
export const EFArrowRightBlueSmall: any = dynamic(() => import('./Icons/EFArrowRightBlueSmall'), {
    ssr: false,
});
export const EFDownLoad = dynamic(() => import('./Icons/EFDownLoad'));
export const EFVideoPauseH5 = dynamic(() => import('./Icons/EFVideoPauseH5'));
export const EFVideoFullScreenH5 = dynamic(() => import('./Icons/EFVideoFullScreenH5'));
export const EFVideoPlayH5 = dynamic(() => import('./Icons/EFVideoPlayH5'));
export const EFVideoPlayBigH5 = dynamic(() => import('./Icons/EFVideoPlayBigH5'));
export const EFVideoPauseBigH5 = dynamic(() => import('./Icons/EFVideoPauseBigH5'));
export const EFVideoReplay = dynamic(() => import('./Icons/EFVideoReplay'));
export const EFVideoReplayH5 = dynamic(() => import('./Icons/EFVideoReplayH5'));
export const EFVideoReplayWhite = dynamic(() => import('./Icons/EFVideoReplayWhite'));
export const EFArrowRightUp = dynamic(() => import('./Icons/EFArrowRightUp'));
export const EFArrowRightUpNew = dynamic(() => import('./Icons/EFArrowRightUpNew'));
export const EFArrowRightNew = dynamic(() => import('./Icons/EFArrowRightNew'));
export const EFQuestionMark = dynamic(() => import('./Icons/EFQuestionMark'));
export const EFLoadingIcon = dynamic(() => import('./Icons/EFLoadingIcon'));
export const EFVideoReplay2 = dynamic(() => import('./Icons/EFVideoReplay2'));
export const EFAvatorIcon = dynamic(() => import('./Icons/EFAvatorIcon'));
export const EFAlarmClockIcon = dynamic(() => import('./Icons/EFAlarmClockIcon'));
export const EFVideoReplay3 = dynamic(() => import('./Icons/EFVideoReplay3'));
export const FacebookSvg = dynamic(() => import('./Icons/FacebookSvg'));
export const EFVideoReplay4 = dynamic(() => import('./Icons/EFVideoReplay4'));
export const FacebookSvgPc = dynamic(() => import('./Icons/FacebookSvgPc'));
export const TwitterSvg = dynamic(() => import('./Icons/TwitterSvg'));
export const TwitterSvgPc = dynamic(() => import('./Icons/TwitterSvgPc'));
export const OutlookSvg = dynamic(() => import('./Icons/OutlookSvg'));
export const EFMhLottleIcon1 = dynamic(() => import('./Icons/EFMhLottleIcon1'));
export const OutlookSvgPc = dynamic(() => import('./Icons/OutlookSvgPc'));
export const LinkSvg = dynamic(() => import('./Icons/LinkSvg'));
export const LinkSvgPc = dynamic(() => import('./Icons/LinkSvgPc'));
export const EFTruckIcon = dynamic(() => import('./Icons/EFTruckIcon'));
export const EFPureXIcon = dynamic(() => import('./Icons/EFPureXIcon'));
export const EFPureSelectIcon: any = dynamic(() => import('./Icons/EFPureSelectIcon'));
export const EFRightArrow = dynamic(() => import('./Icons/EFRightArrow'));
export const EFCalculatorIcon = dynamic(() => import('./Icons/EFCalculatorIcon'));
export const EFCalculatorIcon2 = dynamic(() => import('./Icons/EFCalculatorIcon2'));
export const ToTopIcon = dynamic(() => import('./Icons/ToTopIcon'));
export const EFOfficalAvatar = dynamic(() => import('./Icons/EFOfficalAvatar'));
export const EFAskMeIcon = dynamic(() => import('./Icons/EFAskMeIcon'));
export const EFMailN = dynamic(() => import('./Icons/EFMailN'));
export const EFWatchVideo = dynamic(() => import('./Icons/EFWatchVideo'));
export const PayPalIcon = dynamic(() => import('./Icons/PayPalIcon'));
export const EFLeftBack = dynamic(() => import('./Icons/EFLeftBack'));
export const EFLeftWhite = dynamic(() => import('./Icons/EFLeftWhite'));
export const EFWatchVideoPc = dynamic(() => import('./Icons/EFWatchVideoPc'));
export const EFWatchVideoH5 = dynamic(() => import('./Icons/EFWatchVideoH5'));
export const EFDownloadAppPCSvg = dynamic(() => import('./Icons/EFDownloadAppPCSvg'));
export const EFDownloadAppH5Svg = dynamic(() => import('./Icons/EFDownloadAppH5Svg'));
export const EFPdfSvg = dynamic(() => import('./Icons/EFPdfSvg'));
export const EFAppQRCode = dynamic(() => import('./Icons/EFAppQRCode'));
export const EFAppArrow = dynamic(() => import('./Icons/EFAppArrow'));
export const EFWalletQuestion = dynamic(() => import('./Icons/EFWalletQuestion'));
